export const LOG_EVENTS = [
    'api.request',
    'hl7.received',
    'hl7.acked',
    'hl7.nacked',
    'sync.batch_success',
    'sync.batch_failed',
    'auth.success',
    'auth.failure',
    'impersonation.start',
    'impersonation.stop',
    'license.denied',
    'tenancy.activate.fetch_failed',
    'role.denied',
    'container.crash',
    'db.connection_failed',
    'ocr.extract_text.error',
    'superset.guest_token.failed',
    'superset.dashboards.failed',
    'staff_voucher.no_trust_key_config',
    'staff_voucher.trust_key_missing',
    'staff_login.voucher_invalid',
    'staff_login.success',
    'op.provisioning',
    'op.scheduled_job',
    'op.sync_agent',
    'op.backup_agent',
    'op.system',
];
//# sourceMappingURL=log-events.js.map